__turbopack_context__.v({
  "bellButton": "BrR7-W_bellButton",
  "manageAlertsButton": "BrR7-W_manageAlertsButton",
  "manageAlertsLink": "BrR7-W_manageAlertsLink",
  "popoutBody": "BrR7-W_popoutBody",
  "popoutContainer": "BrR7-W_popoutContainer",
  "popoutFooter": "BrR7-W_popoutFooter",
  "popoutHeader": "BrR7-W_popoutHeader",
  "popoutTitle": "BrR7-W_popoutTitle",
});
